import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { CartProvider } from './context/CartContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import ReviewsButton from './components/ReviewsButton';
import CartDrawer from './components/CartDrawer';
import AnnouncementBar from './components/AnnouncementBar';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Eyeglasses from './pages/Eyeglasses';
import Sunglasses from './pages/Sunglasses';
import Lenses from './pages/Lenses';
import Kids from './pages/Kids';
import Accessories from './pages/Accessories';
// import Contact from './pages/Contact';
import Reviews from './pages/Reviews';
import ProductDetail from './pages/ProductDetail';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import CheckoutSuccess from './pages/CheckoutSuccess';
import MyOrders from './pages/MyOrders';
import './App.css';

function App() {
  return (
    <CartProvider>
      <Router>
        <div className="App font-poppins">
          <Helmet>
            <meta charSet="utf-8" />
            <title>Mughal Ainak Mahal - Premium Eyewear Shop | Mughalpura, Lahore</title>
            <meta name="description" content="Mughal Ainak Mahal - Premium eyewear shop in Mughalpura, Lahore. Quality eyeglasses, sunglasses, lenses, and professional eye care services." />
          </Helmet>
          
          <ScrollToTop />
          <AnnouncementBar />
          <Navbar />
          
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/eyeglasses" element={<Eyeglasses />} />
              <Route path="/sunglasses" element={<Sunglasses />} />
              <Route path="/lenses" element={<Lenses />} />
              <Route path="/kids" element={<Kids />} />
              <Route path="/accessories" element={<Accessories />} />
              {/* <Route path="/contact" element={<Contact />} /> */}
              <Route path="/reviews" element={<Reviews />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/checkout/success" element={<CheckoutSuccess />} />
              <Route path="/my-orders" element={<MyOrders />} />
            </Routes>
          </main>
          
          <Footer />
          <WhatsAppButton />
          <ReviewsButton />
          <CartDrawer />
        </div>
      </Router>
    </CartProvider>
  );
}

export default App;
